import React, { useState } from "react";
import { Link } from "react-router-dom";
import { FaGreaterThan } from "react-icons/fa6";
import { useSelector } from "react-redux";


const ProgramCard = ({ program, setProgramId, setShow }) => {
  const user = useSelector((state) => state?.user);
  const [imageUri, setImageUri] = useState(program?.program_logo_path);

  return (
    <div className="row p-2 mx-1 campaign_item_card">
      <div className="col-lg-2 col-md-3 position-relative d-none">
        {imageUri ? (
          <div className="campaign_item_card_poster position-relative">
            <img
              src={imageUri}
              className=""
              alt=""
              onError={() => {
                setImageUri(null);
              }}
            />
            <div className="position-absolute bg-primary"></div>
          </div>
        ) : (
          <div className="campaign_item_card_poster position-relative ">
            <div className="bg-white d-flex justify-content-center align-items-center">
              <p className="mb-0 fs-2">
                {program?.program_name[0].toUpperCase()}
                {program?.program_name[1].toUpperCase()}
              </p>
            </div>
            {/* <div className="position-absolute bg-primary">

            </div> */}
          </div>
        )}
      </div>
      <div className="col-lg-12 col-md-9">
        <div className="d-flex flex-wrap justify-content-between  my-2 pb-2  border-bottom ">
          <div className="d-flex align-items-center gap-1 ">
            {/* <img src={''}className="img-fluid social_media_img" alt="" /> */}
            <p className="mb-0"> {program?.program_name}</p>
          </div>
          {/* <span> Platform</span> */}
        </div>
        <div className="row d-flex align-items-center mt-2">
          <div className="col-lg-3 col-md-4 col-sm-4 col-6">
            <div className="d-flex gap-2">
              <p className="mb-0">
                {program?.campaign_count > -1
                  ? program?.campaign_count < 10
                    ? "0" + program?.campaign_count
                    : program?.campaign_count
                  : "00"}
              </p>
              {/* <span className="campaign_sub_card_badge rounded-pill badge_1 ">+00%</span> */}
            </div>
            <div className="d-flex gap-2 align-items-center w-100">
                 <span>Count Of Campaigns</span>
                 {program?.campaign_count===0 ?<span ><Link to="/client/campaigns" style={{textDecoration:'none'}}>Create Campaign</Link></span>:<></>}
            </div>
           
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6">
            {/* <div className="d-flex gap-2">
                    <p className="mb-0">$ 1,903</p>
                    <span
                        className="campaign_sub_card_badge rounded-pill badge_2">+70%</span>
                </div>
                <span>Impressions</span> */}
          </div>
          <div className="col-lg-2 col-md-4 col-sm-4 col-6">
            {/* <div className="d-flex gap-2">
                    <p className="mb-0">$ 1,903</p>
                    <span
                        className="campaign_sub_card_badge rounded-pill badge_2">+70%</span>
                </div>
                <span>Clicks</span> */}
          </div>
          <div className="col-lg-1 col-md-4 col-sm-4 col-6">
            {/* <div className="d-flex gap-2">
                    <p className="mb-0">$ 1,903</p>
                    <span
                        className="campaign_sub_card_badge rounded-pill badge_1">+70%</span>
                </div>
                <span>CTR</span> */}
          </div>
          <div className="col-lg-1"></div>
          <div className="col-lg-3  d-flex justify-content-end">
            {!user?.is_super_admin && (
              <Link
                to="#"
                onClick={() => {
                  setProgramId(program?.program_id);
                  setShow(true);
                }}
                className="btn btn-md gap-1 d-flex align-items-center justify-content-center "
              >
                Edit
                <FaGreaterThan className="fs-6" />
              </Link>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgramCard;
